import React, { PropsWithChildren } from "react";
//#region types
import { GroupSectionProps } from "models/propTypes/genericFormProps";
//#endregion
//#region components
import { Grid, Divider } from "@mui/material";
import Icon from "../../icon";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import clsx from "clsx";
import { LocalizationHelperInstance } from "utils/helpers";

const GroupSection: React.FC<PropsWithChildren<GroupSectionProps>> = (props) => {
  return (
    <Grid id={props.navKey} item container className={clsx(cssExports.fieldGroupSection, props.className)}>
      <Grid item container className={cssExports.formSectionHeader} alignItems="center" spacing={2}>
        <Grid item container direction="row">
          {props.icon && (
            <Grid item>
              <Icon icon={props.icon} />
            </Grid>
          )}
          <Grid item>{LocalizationHelperInstance.getFormattedMessage(props.header, props.header)}</Grid>
        </Grid>
        <Grid item container className={cssExports.border}>
          <Divider className={cssExports.dividerGray} />
        </Grid>

        {props.description && (
          <Grid item container className={cssExports.formControlDescription} alignItems="center">
            {LocalizationHelperInstance.getFormattedMessage(props.description, props.description)}
          </Grid>
        )}
      </Grid>
      {props.children}
    </Grid>
  );
};

export default GroupSection;
